export default "__VITE_ASSET__DnPH$$r$__"